import { AppProviders } from './providers/AppProviders';
import { AppRouter } from './router/AppRouter';
import { AiAssistant } from '@/shared/ui/assistant/AiAssistant';
import type { ReactNode } from 'react';

export function App(): ReactNode {
  return (
    <AppProviders>
      <AppRouter />
      {/* Global floating AI assistant — overlays every route. */}
      <AiAssistant />
    </AppProviders>
  );
}
